export const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  })
export const checking = [
    {
        value:"Yes",
        label:"Yes"
    },
    {
        value:"No",
        label:"No"
    }
];

export const gender = [
    {
        value:"Male",
        label:"Male"
    },
    {
        value:"Female",
        label:"Female"
    }
];

export const species = [
    {
        value:"Cow",
        label:"Cow"
    },
    {
        value:"Goat",
        label:"Goat"
    },
    {
        value:"Horse",
        label:"Horse"
    },
    {
        value:"Pig",
        label:"Pig"
    },
    {
        value:"Rabbit",
        label:"Rabbit"
    },
    {
        value:"Sheep",
        label:"Sheep"
    },
]

export const Statusad = [
    {
        value:"Alive",
        label:"Alive"
    },
    {
        value:"Dead",
        label:"Dead"
    }
];